const __WEBPACK_NAMESPACE_OBJECT__ = {"API_URL":"https://x0mhhn72si.execute-api.ap-south-1.amazonaws.com/prod-ae/v1/","SECRET_KEY":"secret"};